import { render, staticRenderFns } from "./invoice-manage.vue?vue&type=template&id=3db5bd38&scoped=true&"
import script from "./invoice-manage.vue?vue&type=script&lang=ts&"
export * from "./invoice-manage.vue?vue&type=script&lang=ts&"
import style0 from "./invoice-manage.vue?vue&type=style&index=0&id=3db5bd38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db5bd38",
  null
  
)

export default component.exports